import { IUserRole } from '../user-role/user-role.interface'

export enum providerTypes {
  oidc = 'OIDC',
  local = 'LOCAL'
}

export enum providerStrategy {
  local = 'local',
  oidc = 'oidc'
}

export interface IAuthProvider extends IBaseAuthProvider {
  _id: string
}

export interface IUpdateAuthProvider extends IBaseAuthProvider {
  _id: string
}

export interface ICreateAuthProvider extends IBaseAuthProvider {}

interface IBaseAuthProvider {
  enabled: boolean
  strategy: providerStrategy
  display_name: string
  type: providerTypes
  config: IOidcProvider
}

export interface IOidcProvider {
  endpoint_url: string
  client_id: string
  client_secret: string
  redirect_uri: string
  logout_url: string
  scope: string[]
  enable_self_registration: boolean
  auto_assign_user_roles: IUserRole | string
}
